import React, { useEffect } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getVestBySlug } from '../data/vesti';
import Contact from '../containers/Contact/Contact';
import Footer from '../containers/Footer/Footer';
import '../containers/Vesti/vesti.css';

const VestDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation('global');
  const vest = getVestBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!vest) {
    return <Navigate to="/vesti" replace />;
  }

  const item = t(`vesti.items.${vest.slug}`, { returnObjects: true });
  const body = Array.isArray(item.body) ? item.body : [];

  return (
    <>
      <article className="vest-detail">
        <Link to="/vesti" className="vest-detail__back">
          ← {t('vesti.back')}
        </Link>
        <h1 className="vest-detail__title">{item.title}</h1>
        <div className="vest-detail__body">
          {body.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
        <div className="vest-detail__image">
          <img src={vest.imageDetail} alt={item.title} />
        </div>
      </article>
      <Contact />
      <Footer />
    </>
  );
};

export default VestDetail;
